import React from 'react'

import { saveOf } from './saving'

export const NAME = 'ROOT'

export const types = {
  REDIRECT_TO: `${NAME}/REDIRECT_TO`,
  RESET_REDIRECT: `${NAME}/RESET_REDIRECT`,
  SHOW_ALERT: `${NAME}/SHOW_ALERT`,
  HIDE_ALERT: `${NAME}/HIDE_ALERT`,
}

export const initialState = {
  redirect: undefined,
  // Какие сохранения форм идут сейчас (имя сохранения → true), см. saving.js.
  saving: {},
  // Сколько сообщений показано за сеанс: по нему видно, показало ли что-то само сохранение.
  alertCount: 0,
  alert: {
    show: false,
    alertTitle: '',
    alertText: '',
    severity: 'error',
    style: {},
    variant: 'outlined'
  }
}
export function reducer(state = initialState, action) {
  switch (action.type) {
    case types.REDIRECT_TO:
      return {
        ...state,
        redirect: action.payload
      }
    case types.RESET_REDIRECT:
      return {
        ...state,
        redirect: undefined
      }
    case types.SHOW_ALERT:
      return {
        ...state,
        alert: action.payload,
        alertCount: state.alertCount + 1
      }
    case types.HIDE_ALERT:
      return {
        ...state,
        alert: action.payload
      }
    default: {
      const save = saveOf(action.type)
      if (save) {
        return { ...state, saving: { ...state.saving, [save.name]: save.stage === 'REQUEST' } }
      }
      return { ...state }
    }
  }
}